import React, {Component} from 'react';
import {client} from '../../Client';
import MenuButton from './MenuButton';
import LogoutButton from './LogoutButton';

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let topbarBckColor = "#005BAB";
    if (client.getCurrentUser().bckcolor1 !== ""){
      topbarBckColor = client.getCurrentUser().bckcolor1;
    }
    return (<div id="topbar" className="ui fixed top menu no-print" style={{backgroundColor: topbarBckColor}}>
      <MenuButton
        sideMenuVisible={this.props.sideMenuVisible}
        onMenuClick={this.props.onMenuClick}
      />
      <img className="ui middle aligned image" width="64px" height="64px" src="/images/logo-sbpiu.png" alt="Studio Ingegneria Bolli - Studio Web"/>
      <a className="item"> <h2>{client.getNomeApp()} <span className="ui grey tiny label"> {client.getVersione()}</span></h2></a>
      <div className="menu right ">
        <LogoutButton/>
      </div>
    </div>)
  }
}

export default TopBar;




/** WEBPACK FOOTER **
 ** ./src/components/main/TopBar.js
 **/